<template>
  <div>
    <b-tabs nav-class="d-print-none">
      <b-tab :title="trans('chart')" lazy>
        <datacandy-chart :organization="organization" :weeks="weeks" class="my-4"></datacandy-chart>
      </b-tab>
      <b-tab :title="trans('data') + ' ' + trans('weeks')" lazy>
        <datacandy-table type="weekly" :organization="organization" class="my-4"></datacandy-table>
      </b-tab>
      <b-tab :title="trans('data') + ' ' + trans('months')" lazy>
        <datacandy-table type="monthly" :organization="organization" class="my-4"></datacandy-table>
      </b-tab>
    </b-tabs>
  </div>
</template>

<script>
  import DatacandyChart from './DatacandyWeeklyMonthlyChart'
  import DatacandyTable from './DatacandyWeeklyMonthlyTable'

  export default {
    props: [
      'organization',
      'weeks',
    ],
    components: {
      DatacandyChart,
      DatacandyTable,
    },
    data() {
      return {
        trans: trans,
        numeral: numeral,
        moment: moment,
        error: null,
        busy: false,
      }
    },
    methods: {
    },
    mounted() {
      window.weeklyMonthlyComponent = this
    },
  }
</script>